import React, { useEffect } from 'react'

import { SinglePanel } from '@/components/common/panel'
import { useRouter, useGlobalContext } from '@/components/context'
import { teamMetricsDefaultUrl } from '@/utils/url'


export const NoTeamPage = () => {
	const router = useRouter()
	const { organisation } = useGlobalContext()

	const modules = organisation.suite.moduleSetItems
	const moduleSetItemWithTeams = modules.find(msi => msi.module.teams.length > 0)

	useEffect(
		() => {
			if(moduleSetItemWithTeams) {
				router.history.push(teamMetricsDefaultUrl({ organisation }))
			}
		},
	)

	return (
		<SinglePanel type="thin">
			<h1>Sorry!</h1>
			<h4>
				You haven't been assigned to a {organisation.suite.moduleWord.toLocaleLowerCase()},
				please contact your administrator.
			</h4>
		</SinglePanel>
	)
}
